import {erc20ABI, getWalletClient} from '@wagmi/core';
import * as chains from '@wagmi/core/chains';

export const DepositToAccountType = {
  spot: 1,
  contract: 2,
} as const;

export async function sendTransaction(params: SendTransactionParams) {
  const walletClient = await getWalletClient();
  const {walletAddress, contractAddress, network: chainId, receiveAddress, amount} = params;
  const chain = getChain(chainId);

  // 本链币，将使用receiveAddress
  const address = (contractAddress || receiveAddress) as any;
  await walletClient.writeContract({
    account: walletAddress,
    address,
    functionName: 'transfer',
    abi: erc20ABI,
    chain: chain,
    args: [receiveAddress as any, amount],
  });
}

export function getChain(chainId) {
  let cacheData = (getChain as any)._supportChains;
  if (!cacheData) {
    cacheData = {};
    for (const item in chains) {
      const chain = chains[item];
      if (chain.hasOwnProperty('id')) {
        cacheData[chain.id] = chain;
      }
    }
    (getChain as any)._supportChains = cacheData;
  }
  return cacheData[chainId];
}

export interface SendTransactionParams {
  walletAddress: string;
  contractAddress: string;
  network: string | number;
  receiveAddress: string;
  amount: bigint;
}
